import { LoadingStateInterface } from 'src/store/loading/state';

export function something(state: LoadingStateInterface) {
  return state.boards /* || state.executions || state.statistics*/;
}

export function executions(state: LoadingStateInterface) {
  return state.executions;
}

export function boards(state: LoadingStateInterface) {
  return state.boards;
}

export function postings(state: LoadingStateInterface) {
  return state.postings;
}

export function statistics(state: LoadingStateInterface) {
  return state.statistics;
}
